import { Route, Routes, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import AppLayout from 'src/layout/AppLayout';
import Home from 'src/pages/Home';
import ComingSoon from 'src/pages/ComingSoon';
import CollectionDetail from 'src/pages/collection/CollectionDetail';
import RaffleList from 'src/pages/raffle/RaffleList';
import Profile from 'src/pages/profile/Profile';
import JoinRaffle from 'src/pages/raffle/JoinRaffle';
import LeaderBoard from 'src/pages/leaderboard/LeaderBoard';
import CreateRaffle from 'src/pages/raffle/CreateRaffle';
import WinnerTestPage from 'src/pages/test/WinnerTestPage';
import TwitterCallback from 'src/components/twitter/TwitterCallback';
import TelegramCallback from 'src/components/telegram/TelegramCallback';
import DiscordCallback from 'src/components/discord/DiscordCallback';

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    const mainElement = document.getElementById('app-layout-main');

    if (mainElement) {
      mainElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [location.pathname]);

  return children;
};

export default function AppRouter() {
  return (
    <Wrapper>
      <Routes>
        <Route index element={<ComingSoon />} />

        <Route path="/home" element={<AppLayout />}>
          <Route index element={<Home />} />
        </Route>

        <Route path="/collection" element={<AppLayout />}>
          <Route path=":id" element={<CollectionDetail />} />
        </Route>

        <Route path="/raffle" element={<AppLayout />}>
          <Route index element={<RaffleList />} />
          <Route path=":id" element={<JoinRaffle />} />
          <Route path="create" element={<CreateRaffle />} />
        </Route>

        <Route path="/profile" element={<AppLayout />}>
          <Route index element={<Profile />} />
        </Route>

        <Route path="/leaderboard" element={<AppLayout />}>
          <Route index element={<LeaderBoard />} />
        </Route>

        <Route path="/test/winner" element={<AppLayout />}>
          <Route index element={<WinnerTestPage />} />
        </Route>
        <Route path="auth/discord/callback" element={<DiscordCallback />} />
        <Route path="auth/twitter/callback" element={<TwitterCallback />} />
        <Route path="auth/telegram/callback" element={<TelegramCallback />} />
      </Routes>
    </Wrapper>
  );
}
